import { useState, useEffect } from "react";
import { Row, Col, Card, Typography, Spin, Dropdown } from "antd";
import {
  TeamOutlined,
  FileTextOutlined,
  ThunderboltOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { getDoctorDashboard } from "../../utils/api-lists/doctor.api";

const { Text } = Typography;

export default function DashboardStats() {
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [adherencePeriod, setAdherencePeriod] = useState("monthly");

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const data = await getDoctorDashboard();
        setDashboardData(data);
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const adherenceData = dashboardData?.adherence?.[adherencePeriod] || {};

  const periodLabels = {
    daily: "Today",
    weekly: "This Week",
    monthly: "This Month",
  };

  const menuItems = [
    {
      key: "daily",
      label: "Daily",
      onClick: () => setAdherencePeriod("daily"),
    },
    {
      key: "weekly",
      label: "Weekly",
      onClick: () => setAdherencePeriod("weekly"),
    },
    {
      key: "monthly",
      label: "Monthly",
      onClick: () => setAdherencePeriod("monthly"),
    },
  ];

  const stats = [
    {
      title: "Clients in Program",
      value: dashboardData?.patients_count || 0,
      icon: <TeamOutlined />,
      color: "#8b5cf6",
    },
    {
      title: "Reports Ready",
      value: dashboardData?.reports_finished || 0,
      icon: <FileTextOutlined />,
      color: "#3b82f6",
    },
    {
      title: `Adherence ${periodLabels[adherencePeriod]}`,
      value: `${adherenceData.percentage || 0}%`,
      icon: <ThunderboltOutlined />,
      color: "#22c55e",
    },
  ];

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px 0" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Row gutter={[24, 24]}>
      {stats.map((item, index) => (
        <Col xs={24} md={8} key={item.title}>
          <Card
            style={{
              background: "rgba(88, 80, 109, 0.30)",
              borderRadius: 16,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div
                style={{
                  background: item.color,
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: 22,
                }}
              >
                {item.icon}
              </div>

              {index === 2 && (
                <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
                  <DownOutlined
                    style={{
                      color: "#9ca3af",
                      fontSize: 16,
                      cursor: "pointer",
                    }}
                  />
                </Dropdown>
              )}
            </div>

            <div style={{ marginTop: 16 }}>
              <Text style={{ color: "#9ca3af" }}>
                {item.title}
              </Text>
              <div
                style={{
                  fontSize: 32,
                  fontWeight: 700,
                  color: "#fff",
                }}
              >
                {item.value}
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
